import React, { useEffect } from "react";

const Pesquisa: React.FC = () => {
  useEffect(() => {
    return () => {
      const widgetContainer = document.getElementById("track__widget");
      if (widgetContainer) {
        widgetContainer.remove();
      }
    };
  }, []);

  return null;
};

export default Pesquisa;
